import React from 'react';
import { cn } from '@/utils/cn';
import { SEE_DETAILS } from '@/constants';
import Icon from '../Icon';
import ButtonLabel from '../Typography/ButtonLabel';

function SeeDetailsButton({ className = '', isShowIcon = true, ...rest }) {
  return (
    <button
      type="button"
      aria-label={SEE_DETAILS}
      className={cn(
        'rounded-[100px] w-[124px] lg:w-[200px] h-[24px] lg:h-[36px] flex justify-center items-center gap-[4px] bg-white border border-pacific-queen hover:bg-placebo-green',
        className,
      )}
      {...rest}
    >
      {isShowIcon && (
        <Icon type="see-details" className="size-[16px] lg:size-[24px]" />
      )}

      <ButtonLabel
        label={SEE_DETAILS}
        className={cn(
          'text-xs lg:text-sm font-semibold lg:font-bold text-center text-pacific-queen',
        )}
      />
    </button>
  );
}

export default SeeDetailsButton;
